import PropTypes from 'prop-types';
import { memo } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box, Link } from '@mui/material';
// Import images
import logoImage from '../../assets/images/illustrations/logo.png';

// ----------------------------------------------------------------------

function Logo({ single = false, sx }) {
  const logo = (
    <img
      src={logoImage}
      alt={single ? 'Single Logo' : 'Full Logo'}
      style={{ width: single ? 124 : 135, height: '100%' }}
    />
  );

  return (
    <Link
      component={RouterLink}
      color="inherit"
      aria-label="go to homepage"
      sx={{ lineHeight: 0 }}
      onClick={() => {
        window.location.href = '/';
      }}
    >
      <Box
        sx={{
          width: single ? 128 : 210,
          lineHeight: 0,
          cursor: 'pointer',
          display: 'inline-flex',
          ...sx,
        }}
      >
        {logo}
      </Box>
    </Link>
  );
}

Logo.propTypes = {
  single: PropTypes.bool,
  sx: PropTypes.object,
};

export default memo(Logo);
